import { Module, VuexModule, Mutation } from 'vuex-module-decorators'
import {
  resolveInitialLanguage,
  SupportedLanguage,
} from '@/scripts/root/language'

@Module({ name: 'langs' })
class LangsModule extends VuexModule {
  appLanguage = resolveInitialLanguage()

  get getAppLanguage(): string {
    return this.appLanguage
  }

  @Mutation
  setAppLanguage(language: SupportedLanguage): void {
    this.appLanguage = language
    localStorage.setItem('language', language)
  }
}

export default LangsModule
